import { z } from 'zod';

/**
 * configEntrySchema — POST / PUT body validation
 * configKey: 소문자 + 숫자 + 하이픈 + 점 조합 (공백/대문자 불허 — CFGCTR-422-001)
 */
export const configEntrySchema = z.object({
  configKey: z
    .string()
    .min(1, '설정 키를 입력하세요')
    .max(160, '키는 160자 이하입니다')
    .regex(
      /^[a-z0-9][a-z0-9\-._]*$/,
      '키는 소문자/숫자/하이픈/점만 사용 가능합니다 (대문자·공백 금지)'
    ),
  configValue: z.string().min(0).max(1024, '값은 1024자 이하입니다'),
  valueType: z.enum(['STRING', 'INT', 'LONG', 'BOOLEAN'], {
    errorMap: () => ({ message: '타입을 선택하세요' }),
  }),
  sensitive: z.boolean().default(false),
  description: z.string().max(512, '설명은 512자 이하입니다').optional().default(''),
});

export type ConfigEntryFormValues = z.infer<typeof configEntrySchema>;
